import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/app/src/layout.tsx";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Content = makeShortcode("Content");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Content mdxType="Content">
      <p>{`We offer ski course opportunities at Studničky for elementary and secondary school students.`}</p>
      <p>{`We’ve prepared two discounted packages for you:`}</p>
      <h2>{`Ski Courses `}<br />{` with a COMPLETE SERVICE PACKAGE`}</h2>
      <ul>
        <li parentName="ul">{`Full-day ski pass`}</li>
        <li parentName="ul">{`Delicious homemade full board (breakfast, lunch, dinner)`}</li>
        <li parentName="ul">{`Drinking regime provided`}</li>
        <li parentName="ul">{`4-night accommodation (Monday – Friday) right next to the slope at Hotel Studničky`}</li>
        <li parentName="ul">{`Minimum number of guests: 40`}</li>
      </ul>
      <h2>{`Ski Courses `}<br />{` with a MEAL PACKAGE for Commuters`}</h2>
      <ul>
        <li parentName="ul">{`Full-day ski pass`}</li>
        <li parentName="ul">{`Drinking regime provided`}</li>
        <li parentName="ul">{`Rich snack and lunch menu`}</li>
      </ul>
      <h2>{`Bonuses for You`}</h2>
      <p>{`A school trip with us is truly worth it! In addition to great discounts, you’ll also enjoy:`}</p>
      <ul>
        <li parentName="ul">{`Tasty homemade cuisine with gluten-free options`}</li>
        <li parentName="ul">{`Ski equipment storage directly in the hotel – private ski room`}</li>
        <li parentName="ul">{`Full-day ski pass included in the package`}</li>
        <li parentName="ul">{`4 ski lifts for beginners and advanced skiers (total slope length: 1400 m)`}</li>
        <li parentName="ul">{`Technically snow-covered and daily groomed slopes`}</li>
        <li parentName="ul">{`Full ski equipment rental and ski service (for an additional fee)`}</li>
        <li parentName="ul">{`Free parking`}</li>
      </ul>
      <p>{`If you're interested or have any questions, don’t hesitate to `}<a parentName="p" {...{
          "href": "/contact/"
        }}>{`contact us`}</a>{`.`}</p>
    </Content>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      